import { registerPageInit } from '../barba/page-init-registry';
import '../../css/pages/clusters/clusters.scss';

class ClustersPage {
  constructor() {}

  public init(): void {
    this.bindEvents();
  }

  private bindEvents(): void {}
}

registerPageInit('cluster-lomonosov-infrastructure', () => {
  const page = new ClustersPage();
  page.init();
});
